<template>
  <MyAccountCheckAuthLoggedIn>
    <MyAccountOrdersShow />
  </MyAccountCheckAuthLoggedIn>
</template>
